import React from 'react';
import GameConfigContainer from './GameConfigContainer';

const GameConfigView = () => {
  return <GameConfigContainer />;
};

export default GameConfigView;
